/**
 * constant file for whole application
 */

const constant = {
  ENV: 3, // DEV:1, STAGE:2, PROD:3
  API_URL: {
    DEV: "https://api.dev.eat-figo.com/api/",
    STAGE: "https://api.myfigo.cloud/api/",
    PROD: "https://api.myfigo.cloud/api/",
  },
  VERSION: {
    V1: "v1/",
    V2: "v2/",
  },
  RESPONSE_CODE: {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    TOKEN_EXPIRED: 600,
  },
  APP_VERSION: "v1.1",
};
export default constant;
